var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import axios from 'axios';
import Entry from 'Entry';
import { ErrorBoundary } from '@datadog/browser-rum-react';
import { datadogRum } from '@datadog/browser-rum';
import ErrorPage from 'components/pages/error-page/ErrorPage';
import { initializeDatadog } from 'config/datadogConfig';
import { APP_BOOTSTRAP_TO_REDIRECT_VITAL } from 'config/datadogVitals';
import { routes } from 'routes/routes';
import { initializeDynamicAssets } from 'utils/dynamicAssets';
import { logger } from 'utils/logger';
import 'i18n';
const startRedirectVital = () => {
    try {
        const { hash, origin } = globalThis.window.location;
        const routeUrl = new URL(hash.slice(1) || '/', origin);
        const shouldRedirect = routeUrl.pathname === routes.APPS && routeUrl.searchParams.get('redirect') === 'true';
        logger.info('Bootstrap redirect vital decision', { route: routeUrl.pathname, shouldRedirect });
        if (!shouldRedirect) {
            return;
        }
        datadogRum.startDurationVital(APP_BOOTSTRAP_TO_REDIRECT_VITAL, {
            description: 'App bootstrap to redirect decision'
        });
    }
    catch (error) {
        logger.warn('Skipping bootstrap redirect vital because initialization failed', { error });
    }
};
export const initializeApp = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        initializeDynamicAssets();
        initializeDatadog();
        startRedirectVital();
        const response = yield axios.get(`/assets/config/${process.env.MANIFEST_FILE}`);
        Window.prototype.config = response.data['global-variables'];
        const root = createRoot(document.getElementById('root'));
        root.render(_jsx(ErrorBoundary, { fallback: ({ error, resetError }) => _jsx(ErrorPage, { error: error, resetError: resetError }), children: _jsx(Entry, {}) }));
        logger.info('App initialized', { manifestFile: process.env.MANIFEST_FILE });
    }
    catch (error) {
        logger.error('Error while fetching manifest file', { error });
    }
});
// Avoid auto-running the app during tests so imports are side-effect free in Jest.
if (process.env.NODE_ENV !== 'test') {
    void initializeApp();
}
